// Plain-English names for violation types and enforcement response levels,
// shared by the IU and Coordinator screens.

export const VIOLATION_PLAIN: Record<string, string> = {
  max_exceeds:        "Daily maximum exceeded",
  avg_exceeds:        "Monthly average exceeded",
  weekly_avg_exceeds: "Weekly average exceeded",
  below_min:          "Below minimum limit",
  above_max:          "Above maximum limit",
  flow_exceeds:       "Flow limit exceeded",
  insufficient_sensitivity: "Lab method not sensitive enough (reporting limit above required PQL)",
  missing_sample:     "Required sample not taken",
};

export const ENFORCEMENT_PLAIN: Record<string, string> = {
  phone_call:  "Phone call",
  warning:     "Warning letter",
  nov:         "Notice of Violation",
  ao:          "Administrative Order",
  civil:       "Civil penalty",
  criminal:    "Criminal referral",
  termination: "Service termination",
};
